import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-message-dialog',
  templateUrl: 'message-dialog.component.html',
  styleUrls: ['message-dialog.component.scss'],
})
export class MessageDialogComponent {

  @Input() title: string;
  @Input() message: string;
  @Input() ok: string;

  constructor(protected ref: NbDialogRef<MessageDialogComponent>) { }

  dismiss() {
    this.ref.close();
  }
}
